(function () {
  "use strict";

  var root = document.getElementById("impact26-root");
  if (!root) return;

  var reducedMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (reducedMotion) root.classList.add("i26-reduced-motion");

  /* Hero photo wall and the logo marquee are both static, hand-curated
     markup with CSS-only drift - no JS build step needed here. Motion
     never pauses or changes speed on hover, on either one (see the note
     in impact26.css above .i26-wstack and .i26-mq-track): the old
     `.i26-hero:hover .i26-wstack { animation-duration: var(--slow) }`
     rule caused the reported hover jump (changing animation-duration
     mid-animation makes the browser recompute progress against the new
     duration, which visibly skips a frame) and has been removed entirely,
     not just tuned. */

  /* ============================================================
     LIVE COUNTER: seed value accrues at a fixed monthly rate from a fixed
     seed date to page-load time, then ticks +1 every 3 seconds while the
     page stays open. Never a value derived from the calendar alone.
     ============================================================ */
  (function liveCounter() {
    // Every element carrying the .i26-counter class (the stat strip figure and
    // the hero panel's counter line) is painted from the same clock on every
    // tick, so the two numbers can never disagree.
    var els = document.querySelectorAll(".i26-counter");
    if (!els.length) return;
    var primary = els[0];
    var seedDate = Date.parse(primary.getAttribute("data-seed-date")) || Date.UTC(2026, 8, 1, 0, 0, 0);
    var seedValue = parseInt(primary.getAttribute("data-seed-value"), 10) || 104000;
    var monthlyRate = parseInt(primary.getAttribute("data-monthly-rate"), 10) || 25000;
    var msPerLoad = (30 * 24 * 60 * 60 * 1000) / monthlyRate; // ~104s per load at 25k/30days
    var startedAt = Date.now();
    var accruedAtLoad = Math.floor((startedAt - seedDate) / msPerLoad);
    var tickSeconds = parseInt(primary.getAttribute("data-tick-seconds"), 10) || 3;
    var TICK_MS = tickSeconds * 1000; // visible +1 tick rate, independent of the real accrual rate above
    function render() {
      var liveTicks = Math.floor((Date.now() - startedAt) / TICK_MS);
      var txt = (seedValue + accruedAtLoad + liveTicks).toLocaleString("en-US");
      for (var i = 0; i < els.length; i++) els[i].textContent = txt;
    }
    render();
    if (!reducedMotion) setInterval(render, 1000);
  })();

  /* ============================================================
     LAZY VIDEO: load + play on intersection, pause off-screen
     ============================================================ */
  (function lazyVideos() {
    var videos = root.querySelectorAll("video[data-src]");
    if (!videos.length) return;
    if (!("IntersectionObserver" in window)) {
      videos.forEach(function (v) {
        v.src = v.getAttribute("data-src");
        v.setAttribute("autoplay", "");
        v.play && v.play().catch(function () {});
      });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (entry.isIntersecting) {
          if (!v.src) v.src = v.getAttribute("data-src");
          v.play && v.play().catch(function () {});
        } else {
          v.pause && v.pause();
        }
      });
    }, { rootMargin: "200px 0px" });
    videos.forEach(function (v) { io.observe(v); });
  })();

  /* ============================================================
     COUNTY MAP + ZIP LOCATOR (transplanted from
     sections/social-impact-2026-07.liquid, ids renamed i26-*)

     Build 9 changes: removed the curated 10-pin named-partner layer and
     the Alaska inset chip entirely (every county already carries one
     uniform mint tint and a data-charity partner, so a handful of labelled
     pins implied wrongly that only those ten had a partner). Hover/tap
     highlights the matched partner's whole territory (unchanged mechanic:
     applyActive already walks every county in that shelter's `counties`
     list) and the tooltip now names the partner and its county count
     instead of "county, state / nearest partner".

     Build 10 (variant B, dots, ported from comps/map-variants.html): county
     fill is now one pale tint, and a static dot layer - one per partner
     with territory on the map, at that partner's territory centroid -
     replaces the single marker build 9 dropped only on zip search. Hover,
     tap-lock, zip search and partner search all now route through one
     setActiveDot() that grows/shrinks dots, so there is only ever one
     active-dot state, not a separate marker layered on top.
     ============================================================ */
  (function initMap() {
    var placeholder = document.getElementById("i26-map-svg-placeholder");
    if (!placeholder) return;
    var svgSrc = placeholder.getAttribute("data-src");
    var sheltersSrc = placeholder.getAttribute("data-shelters-src");

    var charityMeta = {};
    var zipToSlugs = {};
    var prefixToSlugs = {};
    var prefixNearest = {};

    function expandZipRanges(str) {
      var out = [];
      if (!str) return out;
      var parts = str.split(/\s*,\s*/);
      for (var i = 0; i < parts.length; i++) {
        var m = parts[i].match(/^(\d{3,5})(?:-(\d{3,5}))?$/);
        if (!m) continue;
        var a = parseInt(m[1], 10);
        var b = m[2] ? parseInt(m[2], 10) : a;
        for (var z = a; z <= b; z++) out.push(("00000" + z).slice(-5));
      }
      return out;
    }

    function loadShelters() {
      return fetch(sheltersSrc).then(function (r) { return r.json(); }).then(function (data) {
        var shelters = data.shelters || data;
        prefixNearest = data.prefix_nearest || {};
        for (var i = 0; i < shelters.length; i++) {
          var s = shelters[i];
          charityMeta[s.slug] = s;
          var zips = expandZipRanges(s.zip_code_ranges);
          var seenPrefix = {};
          for (var j = 0; j < zips.length; j++) {
            var z = zips[j];
            (zipToSlugs[z] || (zipToSlugs[z] = [])).push(s.slug);
            var pref = z.slice(0, 3);
            if (!seenPrefix[pref]) {
              seenPrefix[pref] = true;
              (prefixToSlugs[pref] || (prefixToSlugs[pref] = [])).push(s.slug);
            }
          }
        }
        return shelters;
      });
    }

    function buildPartnerSearch() {
      var listEl = document.getElementById("i26PartnerList");
      var inputEl = document.getElementById("i26PartnerSearchInput");
      if (!listEl || !inputEl) return;
      var allSlugs = Object.keys(charityMeta);

      function render(filterText) {
        var q = (filterText || "").trim().toLowerCase();
        if (!q) { listEl.classList.remove("i26-open"); listEl.textContent = ""; return; }
        var matches = allSlugs.filter(function (slug) {
          var s = charityMeta[slug];
          return (s.name + " " + s.city + " " + s.state).toLowerCase().indexOf(q) !== -1;
        }).slice(0, 25);
        listEl.textContent = "";
        matches.forEach(function (slug) {
          var s = charityMeta[slug];
          var row = document.createElement("div");
          row.className = "i26-partner-row";
          row.setAttribute("data-slug", slug);
          var b = document.createElement("b");
          b.textContent = s.name;
          row.appendChild(b);
          row.appendChild(document.createTextNode(" " + s.city + ", " + s.state));
          row.addEventListener("click", function () {
            lockActive([slug]);
            showResult(s);
          });
          listEl.appendChild(row);
        });
        listEl.classList.toggle("i26-open", matches.length > 0);
      }
      inputEl.addEventListener("input", function () { render(inputEl.value); });
    }

    var applyActive, lockActive, showResult;

    window.initI26Map = function () {
      loadShelters().then(function () {
        var svg = document.getElementById("county-map");
        if (!svg) return;
        svg.setAttribute("id", "i26-county-map");

        var svgNS = "http://www.w3.org/2000/svg";
        var tooltip = document.getElementById("i26Tooltip");
        var mapWrap = svg.closest(".i26-map-wrap");
        var activeSlugs = [];
        var dotOf = {};
        var dotsG = null;

        applyActive = function (slugs) {
          var prev = svg.querySelectorAll("path.i26-active");
          for (var i = 0; i < prev.length; i++) prev[i].classList.remove("i26-active");
          if (!slugs || !slugs.length) return;
          var fipsSet = {};
          slugs.forEach(function (slug) {
            var meta = charityMeta[slug];
            if (meta && meta.counties) meta.counties.forEach(function (f) { fipsSet[f] = true; });
          });
          var paths = svg.querySelectorAll("path");
          for (var j = 0; j < paths.length; j++) {
            var fips = paths[j].getAttribute("data-fips");
            if (fips && fipsSet[fips]) paths[j].classList.add("i26-active");
          }
        };

        // Grows the matched partner's dot and shrinks any previously-active
        // one back down. Independent of applyActive/territory fill so it
        // works from hover, tap-lock, zip search or partner search alike -
        // one function, one active-dot state, no separate marker layer.
        function setActiveDot(slug) {
          var prev = dotsG && dotsG.querySelector(".i26-big");
          if (prev) prev.classList.remove("i26-big");
          if (slug && dotOf[slug]) dotOf[slug].classList.add("i26-big");
        }

        // "Sarah's Circle, Chicago IL, covers 14 counties" - name, city+state,
        // county count. The engine already has county_count on every shelter.
        function setTooltip(slug) {
          if (!tooltip) return;
          var meta = slug && charityMeta[slug];
          tooltip.textContent = "";
          if (!meta) return;
          var count = meta.county_count || (meta.counties ? meta.counties.length : 0);
          var unit = count === 1 ? "county" : "counties";
          var head = document.createElement("div");
          var b = document.createElement("b");
          b.textContent = meta.name;
          head.appendChild(b);
          head.appendChild(document.createTextNode(", " + meta.city + " " + meta.state + ", covers " + count + " " + unit));
          tooltip.appendChild(head);
        }

        function positionTip(e) {
          if (!tooltip || !mapWrap) return;
          var rect = mapWrap.getBoundingClientRect();
          tooltip.style.left = (e.clientX - rect.left) + "px";
          tooltip.style.top = (e.clientY - rect.top) + "px";
        }

        // Works whether the event target is a county <path data-charity> or
        // a dot's <g data-slug> (or one of its two child <circle>s) - so
        // hovering/tapping a dot behaves exactly like hovering/tapping its
        // territory.
        function slugFrom(target) {
          var g = target.closest ? target.closest("g[data-slug]") : null;
          if (g) return g.getAttribute("data-slug");
          if (target.tagName === "path") return target.getAttribute("data-charity");
          return null;
        }

        svg.addEventListener("mouseover", function (e) {
          if (activeSlugs.length) return; // locked, hover does not override
          var slug = slugFrom(e.target);
          if (!slug) return;
          setTooltip(slug);
          if (tooltip) tooltip.classList.add("i26-visible");
          positionTip(e);
          applyActive([slug]);
          setActiveDot(slug);
        });
        svg.addEventListener("mousemove", function (e) { if (tooltip && tooltip.classList.contains("i26-visible")) positionTip(e); });
        svg.addEventListener("mouseout", function (e) {
          if (activeSlugs.length) return;
          var slug = slugFrom(e.target);
          if (!slug) return;
          if (tooltip) tooltip.classList.remove("i26-visible");
          applyActive(null);
          setActiveDot(null);
        });

        // Tap-to-lock (mobile) and click-to-lock (desktop)
        svg.addEventListener("click", function (e) {
          var slug = slugFrom(e.target);
          if (!slug) return;
          if (activeSlugs.length === 1 && activeSlugs[0] === slug) {
            activeSlugs = [];
            applyActive(null);
            setActiveDot(null);
            if (tooltip) tooltip.classList.remove("i26-visible");
            return;
          }
          activeSlugs = [slug];
          setTooltip(slug);
          if (tooltip) tooltip.classList.add("i26-visible");
          positionTip(e);
          applyActive([slug]);
          setActiveDot(slug);
        });

        lockActive = function (slugs) {
          activeSlugs = slugs || [];
          applyActive(activeSlugs);
          setActiveDot(activeSlugs.length === 1 ? activeSlugs[0] : null);
        };

        // Dot layer: one dot per partner with territory drawn on the map, at
        // that partner's territory centroid (average of every matched
        // county's own bbox centre - same maths build 9 used for the single
        // marker it dropped on zip search, now run once for every partner
        // instead of one at a time). Computed at runtime from the already-
        // parsed SVG via getBBox() - measured on the dev preview at ~11ms
        // for all 3,109 paths (260 partner groups), well under the budget
        // for a one-time pass after the SVG and shelters JSON have both
        // loaded, so no separate precomputed asset is needed.
        function buildDotLayer() {
          var sums = {};
          var paths = svg.querySelectorAll("path[data-charity]");
          for (var i = 0; i < paths.length; i++) {
            var slug = paths[i].getAttribute("data-charity");
            if (!slug) continue;
            var box;
            try { box = paths[i].getBBox(); } catch (e) { continue; }
            var s = sums[slug] || (sums[slug] = { sx: 0, sy: 0, n: 0 });
            s.sx += box.x + box.width / 2;
            s.sy += box.y + box.height / 2;
            s.n++;
          }
          var pts = Object.keys(sums).map(function (slug) {
            var s = sums[slug];
            return { slug: slug, x: s.sx / s.n, y: s.sy / s.n };
          });
          pts.sort(function (a, b) { return a.x - b.x; }); // west to east, for the pop-in sweep

          dotsG = document.createElementNS(svgNS, "g");
          dotsG.setAttribute("class", "i26-pdots");
          var vb = svg.viewBox && svg.viewBox.baseVal && svg.viewBox.baseVal.width ? svg.viewBox.baseVal.width : 960;
          pts.forEach(function (p) {
            var g = document.createElementNS(svgNS, "g");
            g.setAttribute("class", "i26-pdot");
            g.setAttribute("data-slug", p.slug);
            g.style.setProperty("--i26-dd", (p.x / vb * 1.26).toFixed(3) + "s");
            var halo = document.createElementNS(svgNS, "circle");
            halo.setAttribute("cx", p.x); halo.setAttribute("cy", p.y);
            halo.setAttribute("class", "i26-pdot-halo");
            var core = document.createElementNS(svgNS, "circle");
            core.setAttribute("cx", p.x); core.setAttribute("cy", p.y);
            core.setAttribute("class", "i26-pdot-core");
            g.appendChild(halo);
            g.appendChild(core);
            dotsG.appendChild(g);
            dotOf[p.slug] = g;
          });
          svg.appendChild(dotsG);

          function settle() {
            dotsG.classList.remove("i26-anim", "i26-go");
            dotsG.classList.add("i26-done");
          }
          if (reducedMotion || !("IntersectionObserver" in window)) {
            dotsG.classList.add("i26-done");
          } else {
            dotsG.classList.add("i26-anim");
            var io = new IntersectionObserver(function (entries) {
              entries.forEach(function (entry) {
                if (!entry.isIntersecting) return;
                io.disconnect();
                dotsG.classList.add("i26-go");
                setTimeout(settle, 1900);
              });
            }, { threshold: 0.1 });
            io.observe(mapWrap || svg);
          }
        }
        buildDotLayer();

        buildPartnerSearch();

        // Zip search
        var form = document.getElementById("i26LocatorForm");
        var input = document.getElementById("i26ZipInput");
        var resultEl = document.getElementById("i26LocatorResult");

        showResult = function (shelterMeta) {
          if (!resultEl) return;
          resultEl.innerHTML = "Your loads go to <b>" + shelterMeta.name + "</b>, " + shelterMeta.city + ", " + shelterMeta.state + ".";
          resultEl.classList.remove("i26-empty");
        };

        function doSearch() {
          var zip = (input.value || "").replace(/\D/g, "");
          if (zip.length !== 5) return;
          var slugs = zipToSlugs[zip];
          if (!slugs || !slugs.length) slugs = prefixToSlugs[zip.slice(0, 3)];
          if (!slugs || !slugs.length) {
            var nearest = prefixNearest[zip.slice(0, 3)];
            if (nearest) slugs = [nearest];
          }
          if (!slugs || !slugs.length) {
            resultEl.innerHTML = "We are still working on getting a partner routed to zip " + zip + ".";
            resultEl.classList.remove("i26-empty");
            lockActive([]);
            return;
          }
          var primary = charityMeta[slugs[0]];
          lockActive([primary.slug]);
          showResult(primary);
        }

        if (form) form.addEventListener("submit", function (e) { e.preventDefault(); doSearch(); });
        if (input) {
          input.addEventListener("input", function () {
            var zip = input.value.replace(/\D/g, "");
            input.value = zip;
            if (zip.length === 5) doSearch();
          });
        }
      });
    };

    // Build 15: the SVG (~207KB) and shelters JSON (~78KB) are the two
    // heaviest same-origin assets on the page. Neither is fetched until the
    // locator section is within ~600px of the viewport, so a visitor who
    // never scrolls this far never pays for either download.
    function loadMap() {
      fetch(svgSrc)
        .then(function (r) { return r.text(); })
        .then(function (svgText) {
          var tmp = document.createElement("div");
          tmp.innerHTML = svgText;
          var svgEl = tmp.querySelector("svg");
          if (svgEl) placeholder.parentNode.replaceChild(svgEl, placeholder);
          if (typeof window.initI26Map === "function") window.initI26Map();
        })
        .catch(function (err) {
          console.warn("Impact 2026: could not load county map SVG", err);
        });
    }

    var mapSection = placeholder.closest(".i26-locator-section") || placeholder;
    if (!("IntersectionObserver" in window)) {
      loadMap();
    } else {
      var mapIo = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          mapIo.disconnect();
          loadMap();
        });
      }, { rootMargin: "600px 0px" });
      mapIo.observe(mapSection);
    }
  })();
})();
